import React, {useState, useEffect} from 'react';
import './index.css';

export const MessageItem = ({key, data, user}) => {
    const [time, setTime] = useState('');

    useEffect(()=>{
      if(data.date > 0){
        let d = new Date(data.date.seconds * 1000);
        let hours = d.getHours();
        let minutes = d.getMinutes();
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0'+ minutes : minutes;
        setTime(`${hours}:${minutes}`);
      }
    },[data])

    return(
        <div className="msg-line" style={{justifyContent: (user.id === data.author)? 'flex-end': 'flex-start'}}>
            <div className={`msg-item ${(user.id === data.author) ? 'user-msg':'friend-msg'}`}>
                <div className="msg-text">{data.body}</div>
                <div className="msg-date">{time}</div>
            </div>
        </div>
    )
}